import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const RestrictionQrValueField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="QRChatBotCodeLabel" value={restaurantForFullInfo?.restrictionQrValue} />;
};

export default RestrictionQrValueField;
